import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true, // httpOnly cookie'lerin gönderilmesi için zorunlu
});

// --- GLOBAL YÜKLEME TAKİBİ ---
// Uçuştaki istek sayısını tutar; YuklemeGostergesi bileşeni bu event'i dinler.
// Render ücretsiz katmanı uykudan uyanırken ilk istek ~30-60 sn sürebildiği
// için kullanıcıya "donma" yerine yükleme durumu göstermek kritik.
let bekleyenIstekSayisi = 0;

const yuklemeDurumuBildir = () => {
  window.dispatchEvent(new CustomEvent('api-yukleme', { detail: { aktif: bekleyenIstekSayisi > 0 } }));
};

export const istekBasladi = () => {
  bekleyenIstekSayisi += 1;
  yuklemeDurumuBildir();
};

export const istekBitti = () => {
  bekleyenIstekSayisi = Math.max(0, bekleyenIstekSayisi - 1);
  yuklemeDurumuBildir();
};

// Her API isteğinden ÖNCE çalışarak access token'ı header'a ekler
// FIX: Token artık localStorage yerine React state'ten (App.js'den aktarılan) geliyor
api.interceptors.request.use(
  (config) => {
    istekBasladi();
    // accessToken window._accessToken üzerinden App.js state'ine bağlı
    const token = window._accessToken || localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    istekBitti();
    return Promise.reject(error);
  }
);

// Bir API isteği HATA verdiğinde çalışır
api.interceptors.response.use(
  (response) => {
    istekBitti();
    return response;
  },
  async (error) => {
    istekBitti();
    const originalRequest = error.config;

    // 401 hatası, daha önce retry denenmemişse VE istek /refresh değilse
    if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.url.includes('/refresh') && !originalRequest.url.includes('/giris')) {
      originalRequest._retry = true;

      try {
        // FIX: Refresh token artık httpOnly cookie'de — interceptor'a yakalanmamak için ham axios kullan
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/refresh`, {}, {
          withCredentials: true // Cookie'nin gitmesi için
        });

        if (res.status === 200) {
          const newAccessToken = res.data.access_token;

          // Yeni access token'ı bellekte ve localstorage'da (yedek olarak) sakla
          window._accessToken = newAccessToken;
          localStorage.setItem('accessToken', newAccessToken);

          // App state'i de güncelle (varsa callback)
          if (window._onTokenRefresh) {
            window._onTokenRefresh(newAccessToken, res.data.kullanici);
          }

          originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        // Refresh başarısız — kullanıcıyı çıkış yaptır
        console.error('Oturum süresi doldu veya refresh token geçersiz. Çıkış yapılıyor.', refreshError);

        // Bellekteki token'ı temizle
        window._accessToken = null;

        // Eski localStorage temizliği
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userRole');

        if (window.location.pathname !== '/') {
          window.location.href = '/';
        }

        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;